const Banner468x60 = ({ refLink }) => (
  <a href={refLink} target="_blank" rel="noopener noreferrer" className="sc-banner-468 block" aria-label="1SimpleCycler 3.0 — Cycle Real Crypto">
    <div className="sc-banner-468-inner">
      <img src="/logo/logo-468.png" alt="1SimpleCycler 3.0" className="sc-banner-468-logo" width="182" height="24" />
      <span className="sc-banner-468-text">CYCLE REAL CRYPTO</span>
      <span className="sc-banner-468-cta">JOIN&nbsp;&rarr;</span>
    </div>
  </a>
);

export default Banner468x60;
